import {
  useMutation,
  UseMutationResult,
  useQuery,
} from "@tanstack/react-query";
import { Badges } from "../products/badges";

export function useCreateBadges(): any {
  return useMutation({
    mutationFn: (body: any) => Badges.createBadges(body),
  });
}

export function useGetBadgesData(option?: any) {
  const { data, isLoading, error, status, isSuccess, refetch } = useQuery<any>({
    queryKey: ["GetBadgesData"],
    queryFn: () => Badges.GetBadgesData(option),
  });

  return {
    GetBadgesData: data,
    GetBadgesDataLoading: isLoading,
    error,
    status,
    isSuccess,
    GetBadgesDataRefetch: refetch,
  };
}
export function useGetUserChallenges(option?: any) {
  const { data, isLoading, error, status, isSuccess, refetch } = useQuery<any>({
    queryKey: ["getUserChallengesData"],
    queryFn: () => Badges.GetUserChallengesData(option),
  });

  return {
    challengesData: data,
    challengesLoading: isLoading,
    error,
    status,
    isSuccess,
    challengesRefetch: refetch,
  };
}
export function useGetbadgesById(id?: number) {
  const { data, isLoading, error, status, isSuccess, refetch } = useQuery<any>({
    queryKey: ["useGetbadgesById"],
    queryFn: () => Badges.GetBadgesById(id),
  });

  return {
    GetbadgesById: data,
    GetbadgesByIdLoading: isLoading,
    error,
    status,
    isSuccess,
    GetbadgesByIdRefetch: refetch,
  };
}
export function useUpdateBadges(id: number): any {
  return useMutation({
    mutationFn: (body: any) => Badges.UpdateBadges(body, id),
  });
}
export function useDeleteBadges(): any {
  return useMutation({
    mutationFn: (body: any) => Badges.deleteBadges(body.id),
  });
}
